import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, ActivationEnd } from "@angular/router";
import { filter, map, buffer, pluck } from 'rxjs/operators';
import { Location } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { environment } from 'src/environments/environment';
import * as $ from 'jquery';
interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
}
@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css']
})
export class BreadCrumbComponent implements OnInit {
  // public breadcrumbs: IBreadcrumb[];
  // bcLoadedData;
  // bcForDisplay;
  route: string;
  breadcrumbList: Array<any>;
  routeLinks: number;
  count: number;
  breadCrumb = [];
  userDetails;
  contactDetails =  false;
  environmentURL;
  @ViewChild('contactUs') public contactUs: ModalDirective;
  contactUsData;
  constructor(private location: Location, private router: Router, private commonService: CommonService, private sharedService: SharedService) {
    router.events.subscribe((val) => {
      if (location.path() !== "") {
        this.route = location.path();
        this.breadcrumbList = this.route.split('/');
        if (this.breadcrumbList !== undefined && this.breadcrumbList.length > 0) {
          this.breadcrumbList.forEach((val) => {
            if (val !== "" && val !== "Home") {
              if (this.breadCrumb.includes(val) === false) {
                this.breadCrumb.push(val);
              }
            }
            this.count = this.breadcrumbList.length;
          })
        }
      }
    });
  }

  ngOnInit() {
    this.getUser();

    //console.log('environment' , environment)
    let splitValues;
    let newURL;
    splitValues = environment.baseUrl.split('/');
    //console.log('splitValues : ' + JSON.stringify(splitValues));
    newURL = splitValues[2].split(':');
   // console.log('newURL : ' + JSON.stringify(newURL));
    this.environmentURL = newURL[0]
    // if(newURL == "10.62.0.133"){
    //   this.environmentURL = "10.62.0.134"
    // }else{
    //   this.environmentURL = newURL
    // }

    
  }

  breadCrumbNav(breadLink, error: Response | any) {
   // console.log('breadLink : ' + JSON.stringify(breadLink))
    if (breadLink !== 'Home') {
      this.router.navigateByUrl('/Home/' + breadLink).catch(e => {
        //If specified path is not found
      })
    } else if (breadLink === 'Home') {
      this.router.navigateByUrl('/Home').catch(e => {
        //If home is not found
      })
    } else {
      setTimeout(() => this.router.navigateByUrl('/Home'));
      return error.status;
    }
  }


  getWhosWhoInfo() {
    this.contactUsData = [];
    this.commonService.getHomePageInfo().then((resp: any) => {
      if (resp.status == 200) {
        if (resp['body']) {
          if (resp['body'].responseObject) {

             this.contactUsData = resp['body'].responseObject;
            // for (let i = 0; i < resp['body'].responseObject.whosWho.length; i++) {
            //   if (resp['body'].responseObject.whosWho[i].whosCode == 11) {
            //     for (let j = 0; j < resp['body'].responseObject.whosWho[i].whosWhoDetails.length; j++) {
            //       const obj = {
            //         name: resp['body'].responseObject.whosWho[i].whosWhoDetails[j].name,
            //         phone: resp['body'].responseObject.whosWho[i].whosWhoDetails[j].phone
            //       }
            //       this.contactUsData.push(obj);
            //     }
            //     // this.contactUsData.push(resp['body'].responseObject.whosWho[i].whosWhoDetails);
            //   //  console.log(this.contactUsData);
            //   }
            // }

          }
        }
      } else {
        // this.contactUsData = [];
        this.contactDetails =  false;
      }

    })
  }


  getUser() {
    this.sharedService.getLocalStorageItem('user').then((resp: any) => {
     // console.log('resp : ' + JSON.stringify(resp))
      if (resp) {
        this.userDetails = resp;
      }
    })
  }



  openContact() {
    this.contactUs.show();
    this.contactDetails =  false;
    this.getWhosWhoInfo();
  }


  closeContact() {
    this.contactUs.hide();
    // this.contactUsData = [];
    this.contactDetails =  false;
    let audioPlayer = <HTMLVideoElement>document.getElementById('myVideo');
       audioPlayer.muted = true;
      // audioPlayer.pause();
     
  }

  openContactDetails(){
    this.contactDetails =  true;
  }
  closeContactDetails(){
    this.contactDetails =  false;
  }

}


